import { uploadEntityAttachments, deleteAttachment } from '@/lib/entity-attachments';

export interface BillFileAttachment {
  id: string;
  file_name: string;
  file_type: string;
  file_size: number;
  file_url: string;
  created_at: string;
  created_by: string;
  created_by_user?: {
    display_name?: string | null;
  };
}

export async function uploadBillAttachments(
  billId: string | undefined,
  files: File[],
  companyId: string,
  userId: string
): Promise<BillFileAttachment[]> {
  return uploadEntityAttachments('bill', billId, files, companyId, userId);
}

/** Bill payment attachments (create-mode upload-after-the-payment-exists and the edit-mode form). */
export async function uploadBillPaymentAttachments(
  paymentId: string | undefined,
  files: File[],
  companyId: string,
  userId: string
): Promise<BillFileAttachment[]> {
  return uploadEntityAttachments('bill_payment', paymentId, files, companyId, userId);
}

export function deleteBillAttachment(attachmentId: string, userId: string | undefined): Promise<boolean> {
  return deleteAttachment(attachmentId, userId);
}
